export default __webpack_public_path__ + "static/media/never.b2650ce0.gif";